<div class="row g-0">
  <div class="col-md-4 gradient-custom text-center text-white user-delete-content "
       style="border-top-left-radius: .5rem; border-bottom-left-radius: .5rem; padding-top: 70px;">
    <div class="m-auto">
      <img src="assets/img/remove-user.png" alt="Avatar"
           class="img-fluid mt-5 m-auto" style="width: 80px;"/>
      <div class="card-body text-center mb-3">
        <h4 class="mb-4" style="font-weight: bold;">{{firstName}} {{ lastName}}</h4>

      </div>
    </div>

  </div>
  <div class="col-md-8">
    <div class="modal-header">
      <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="text-center mt-2">
      <h4 class="" style="font-weight: bold; color: red; font-size: larger;">Warning!</h4>
    </div>
    <div class=" p-4" style="padding: 5px">
      <h6 class="fw-bold">User Information</h6>
      <hr class="mt-0 mb-4">
      <div class="row pt-1">
        <div class="col-6 mb-3">
          <h6>Company</h6>
          <p class="text-muted text-truncate">{{company}}</p>
        </div>

      </div>
      <div class="row pt-1">
        <div class="col-6 mb-3">
          <h6>Institution</h6>
          <p class="text-muted text-truncate">{{institution}}</p>
        </div>
      </div>
    </div>
    <div class=" mb-9">
      <h2 class="text-black mt-3 fw-bold" style="margin-left: 20px;">Are you sure you want to delete this portal
        user?</h2>
    </div>

    <div class="modal-footer user-delete-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" type="submit" (click)="onDeletePress()">
        <p>
          Delete
        </p>
      </button>
    </div>

  </div>
</div>
